<ion-content>
  <div class="flex-container">
    <div class="left-column header-row">
      <div class="ion-text-start header-title">
        {{ (action ? 'Add' : 'Edit') | translate }} {{ displayHeaderTitle | translate }}
      </div>
    </div>
    <div class="right-column">
      <img class="close-icon" alt="" tooltip="{{'Close'  | translate }}" placement="bottom" (click)="closeModal()" src="assets/icon/cancel.svg">
    </div>
  </div>
  <div class="main-content">
    <ng-container *ngFor="let item of currentData; let i = index">
      <div *ngIf="showLanguageDropdown" class="form-grid">
        <div class="form-field">
          <ion-label class="label-css">{{ 'Language' | translate }}</ion-label>
          <ng-select
            class="language-select"
            [items]="languageOptions"
            bindLabel="display"
            bindValue="code"
            [(ngModel)]="item.languageCode"
            (ngModelChange)="onDataChange()"
            [clearable]="true"
            appendTo="body"
            placeholder="{{ 'Select Language' | translate }}">
          </ng-select>
        </div>
        <div class="form-field" *ngIf="title === HazardMeasureConstants.MEASURES">
          <ion-label class="label-css">{{ 'Measure Type' | translate }}</ion-label>
          <ng-select
            *ngIf="showMeasureTypeDropdown; else measureTypeReadonly"
            class="measure-type-select"
            [items]="measureTypes"
            bindLabel="measure_type_name"
            [clearable]="true"
            appendTo="body"
            placeholder="{{ 'Enter Type Of Measure' | translate }}"
            [ngModel]="getSelectedMeasureType(item)"
            (ngModelChange)="onMeasureTypeChange(item, $event)">
            <ng-template ng-label-tmp let-option="item">
              {{ getMeasureTypeTranslationKey(option?.measure_type_name) | translate }}
            </ng-template>
            <ng-template ng-option-tmp let-option="item">
              {{ getMeasureTypeTranslationKey(option?.measure_type_name) | translate }}
            </ng-template>
          </ng-select>
          <ng-template #measureTypeReadonly>
            <ion-input class="measure-type-input" [value]="getMeasureTypeTranslationKey(item?.measureType) | translate"
              placeholder="{{ 'Enter Type Of Measure' | translate }}" readonly disabled>
            </ion-input>
          </ng-template>
        </div>
      </div>
      <app-ai-writing-field-shell
        [(ngModel)]="item.machineTitle"
        [maxlength]="maxLength"
        [rows]="2"
        placeholder="{{ (title === HazardMeasureConstants.MEASURES ? 'Enter Measure' : (title === HazardMeasureConstants.INITIAL_HAZARDS ? 'Enter Initial Hazard' : '')) | translate }}"
        (ngModelChange)="onTitleChange(item)"
        [fieldContextType]="(title === HazardMeasureConstants.MEASURES || title === HazardMeasureConstants.INITIAL_HAZARDS) ? 'hazard-measure-library-title' : undefined"
        [historyKey]="'hazard-measure-library-title::' + i">
      </app-ai-writing-field-shell>
      <div class="char-counter" *ngIf="maxLength !== null">
        {{ getCurrentLength(item) }}/{{ maxLength }}
      </div>
    </ng-container>
    <div class="save-button">
      <ion-button class="app-btn margin-right-16" shape="round" fill="outline" color="primary" (click)="closeModal()">
        {{'Cancel'|translate}}
      </ion-button>
      <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="save()" [disabled]="!isDataChange">
        {{'Save'|translate}}
      </ion-button>
    </div>
  </div>
</ion-content>